
import {Component, Mixins} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import RaporQueryBuilderGroup from "@/components/inputs/RaporQueryBuilderGroup.vue";
import {RaporAlanEntity} from "@/entity/RaporAlanEntity";
import RaporQueryBuilderSimple from "@/components/inputs/RaporQueryBuilderSimple.vue";
import {RaporKosulEntity} from "@/entity/RaporKosulEntity";
import RaporKosulGrupEntity from "@/entity/RaporKosulGrupEntity";

@Component({
  components: {RaporQueryBuilderSimple, RaporQueryBuilderGroup}
})
export default class RaporQueryBuilder extends Mixins(ObjectInputMixin) {
  localValue: RaporKosulGrupEntity = new RaporKosulGrupEntity();
  rapor_alanlari_items: Array<RaporAlanEntity> = [];

  mounted() {
    this.load();
    if (!this.localValue.kosullar)
      this.localValue.kosullar = [];
  }

  load() {
    this.$helper.requestWithCache('/api/v1/rapor-alan').then(responce => {
      this.rapor_alanlari_items = responce.data;
    })
  }

  // DEV-3011 — koşul verilemeyen alanlar (izinli operatörü olmayanlar) koşul
  // seçicisinde hiç görünmez; kullanıcı boş sonuç üreten koşul kuramaz.
  get kosulVerilebilirAlanlar() {
    return this.rapor_alanlari_items.filter((a: any) => (a.kosul_operatorleri || []).length > 0);
  }

  veMiSec(deger: boolean) {
    this.$set(this.localValue, "ve_mi", deger);
    this.input();
  }

  /**
   * Tasarımdaki davranış: buton tek tıkla boş bir koşul satırı ekler, alan
   * satırın içinden seçilir. (Önceki akışta önce yukarıdan alan seçilmeden
   * buton pasif kalıyordu ve kullanıcı nedenini göremiyordu.)
   */
  kosulEkle() {
    if (!this.localValue.kosullar) this.$set(this.localValue, "kosullar", []);
    const yeni = new RaporKosulEntity();
    const ilk: any = this.kosulVerilebilirAlanlar[0];
    if (ilk) yeni.rapor_alan_id = ilk.id;
    this.localValue.kosullar.push(yeni);
    this.input();
  }

  kosulGrubuEkle() {
    if (!this.localValue.kosullar) this.$set(this.localValue, "kosullar", []);
    this.localValue.kosullar.push({ve_mi: true, kosullar: []});
    this.input();
  }

  kosulSil(index: number) {
    this.localValue.kosullar.splice(index, 1);
    this.input();
  }
}
